var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "j-modal",
    {
      attrs: {
        title: _vm.title,
        width: _vm.width,
        visible: _vm.visible,
        switchFullscreen: "",
        okDisabled: true,
        cancelText: _vm.language["common.closeButton"]
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel }
    },
    [
      _c(
        "div",
        { staticClass: "table-page-search-wrapper" },
        [
          _c(
            "a-form",
            {
              attrs: { layout: "inline" },
              nativeOn: {
                keyup: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.searchQuery($event)
                }
              }
            },
            [
              _c(
                "a-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "a-col",
                    { attrs: { xl: 6, lg: 7, md: 8, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label:
                              _vm.language[
                                "emp.empEntranceManager.managerWorkNo"
                              ]
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { "allow-clear": "" },
                            model: {
                              value: _vm.queryParam.managerWorkNo,
                              callback: function($$v) {
                                _vm.$set(_vm.queryParam, "managerWorkNo", $$v)
                              },
                              expression: "queryParam.managerWorkNo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { xl: 6, lg: 7, md: 8, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: _vm.language["emp.empEntranceManager.status"]
                          }
                        },
                        [
                          _c("j-dict-select-tag", {
                            attrs: {
                              type: "list",
                              dictCode: "entrance_manager_status",
                              "allow-clear": ""
                            },
                            model: {
                              value: _vm.queryParam.status,
                              callback: function($$v) {
                                _vm.$set(_vm.queryParam, "status", $$v)
                              },
                              expression: "queryParam.status"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("a-col", { attrs: { xl: 6, lg: 7, md: 8, sm: 24 } }, [
                    _c(
                      "span",
                      {
                        staticClass: "table-page-search-submitButtons",
                        staticStyle: { float: "left", overflow: "hidden" }
                      },
                      [
                        _c(
                          "a-button",
                          {
                            attrs: { type: "primary", icon: "search" },
                            on: { click: _vm.searchQuery }
                          },
                          [_vm._v(_vm._s(_vm.language["common.searchButton"]))]
                        ),
                        _c(
                          "a-button",
                          {
                            staticStyle: { "margin-left": "8px" },
                            attrs: { type: "primary", icon: "reload" },
                            on: { click: _vm.searchReset }
                          },
                          [_vm._v(_vm._s(_vm.language["common.resetButton"]))]
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "table-operator" },
        [
          _c(
            "a-button",
            {
              attrs: { type: "primary", icon: "plus" },
              on: { click: _vm.handleAdd }
            },
            [_vm._v(_vm._s(_vm.language["common.insertButton"]))]
          )
        ],
        1
      ),
      _c(
        "div",
        [
          _c("a-table", {
            ref: "table",
            attrs: {
              bordered: "",
              size: "middle",
              rowKey: "id",
              columns: _vm.columns,
              dataSource: _vm.dataSource,
              pagination: false,
              loading: _vm.loading,
              scroll: { x: true }
            },
            on: { change: _vm.handleTableChange },
            scopedSlots: _vm._u([
              {
                key: "action",
                fn: function(text, record) {
                  return _c(
                    "span",
                    {},
                    [
                      record.status == "0"
                        ? _c(
                            "a",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.handleFrozen(record, "1")
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.language["sys.dict.status.freeze"])
                              )
                            ]
                          )
                        : _c(
                            "a",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.handleFrozen(record, "0")
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.language["common.thawButton"]))]
                          ),
                      _c("a-divider", { attrs: { type: "vertical" } }),
                      _c(
                        "a-popconfirm",
                        {
                          attrs: {
                            title: _vm.language["common.deleteConfirmInfo"]
                          },
                          on: {
                            confirm: function() {
                              return _vm.remove(record)
                            }
                          }
                        },
                        [
                          _c("a", [
                            _vm._v(_vm._s(_vm.language["common.delete"]))
                          ])
                        ]
                      )
                    ],
                    1
                  )
                }
              }
            ])
          })
        ],
        1
      ),
      _c("emp-entrance-manager-user-modal", {
        ref: "userModal",
        on: { ok: _vm.searchQuery }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }